(function() {
  const grid = document.querySelector('.lookbook-masonry')
  if (!grid) return

  var items = Array.from(grid.querySelectorAll('.lookbook-item'))
  items
    .sort(function(a, b) {
      return BigInt(b.dataset.id) > BigInt(a.dataset.id) ? 1 : -1
    })
    .forEach(function(item) { grid.appendChild(item) })
})()